import { Routes } from '@angular/router';

import { authGuard } from './auth/guards/auth/auth.guard';
import { isAuthGuard } from './auth/guards/is-auth/is-auth.guard';
import { ChangePasswordComponent } from './auth/pages/change-password/change-password.component';
import { LoginComponent } from './auth/pages/login/login.component';
import { AcademyComponent } from './dashboard/pages/academy/academy/academy.component';
import { PreviewComponent } from './dashboard/pages/academy/preview/preview.component';
import { AcceptQuoteComponent } from './dashboard/pages/accept-quote/accept-quote.component';
import { ActionPlansComponent } from './dashboard/pages/action-plans/action-plans.component';
import { AreasComponent } from './dashboard/pages/areas/areas.component';
import { DashboardComponent } from './dashboard/pages/dashboard/dashboard.component';
import { EventDetailsComponent } from './dashboard/pages/event-details/event-details.component';
import { HomeComponent } from './dashboard/pages/home/home.component';
import { InspectionsComponent } from './dashboard/pages/inspections/inspections.component';
import { MipFoldersComponent } from './dashboard/pages/mip-folders/mip-folders.component';
import { ReportsComponent } from './dashboard/pages/reports/reports.component';
import { SignatureComponent } from './dashboard/pages/signature/signature.component';
import { TasksComponent } from './dashboard/pages/tasks/tasks.component';
import { TracingsComponent } from './dashboard/pages/tracings/tracings.component';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [authGuard]
  },
  {
    path: 'academy',
    component: AcademyComponent,
    canActivate: [authGuard]
  },
  {
    path: 'services',
    component: HomeComponent,
    canActivate: [authGuard]
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'tracings',
    component: TracingsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'tasks',
    component: TasksComponent,
    canActivate: [authGuard]
  },
  {
    path: 'action-plans',
    component: ActionPlansComponent,
    canActivate: [authGuard]
  },
  {
    path: 'mip-folders',
    component: MipFoldersComponent,
    canActivate: [authGuard]
  },
  {
    path: 'inspections',
    component: InspectionsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'areas',
    component: AreasComponent,
    canActivate: [authGuard]
  },
  {
    path: 'event-details/:id',
    component: EventDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'signature/:id',
    component: SignatureComponent,
  },
  {
    path: 'accept-quote/:id',
    component: AcceptQuoteComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [isAuthGuard]
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [authGuard]
  },
  {
    path: 'academy/preview',
    component: PreviewComponent,
    canActivate: [authGuard]
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
